import type { ReactNode } from "react";
import type { DeckType } from "src/api/flashcardDecks";

import { type DeckProgress, DeckInfo } from "./DeckInfo";

interface DefaultAppProps {
	deck: { name: string };
	deckId: number;
	progress: DeckProgress;
	currentMode: DeckType;
	renderFlashcard: () => ReactNode;
}

export function DefaultApp({
	deck,
	deckId,
	progress,
	currentMode,
	renderFlashcard,
}: DefaultAppProps) {
	return (
		<div className="creator-container" data-test-id="flashcard-study-view">
			<div className="creator--box basic-box">
				<DeckInfo
					deck={deck}
					deckId={deckId}
					progress={progress}
					currentMode={currentMode}
				/>
				<div className="flashcard-app--content--box">{renderFlashcard()}</div>
			</div>
		</div>
	);
}
